export const TOGGLE_GETTING_STARTED = 'TOGGLE_GETTING_STARTED';